import {Component, OnInit, Inject, AfterViewInit, ViewChildren} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {DigitalCertificateService} from 'src/app/core/services/digital-certificate.service';
import {UserService} from 'src/app/core/services/user.service';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {Message} from '../../../../../../core/class/message';
import FileUtils, {ContentType} from '../../../../../../core/services/file-utils';
// @ts-ignore
import {NzUploadFile} from 'ng-zorro-antd/upload';
import {Observable, Observer, Subscription} from 'rxjs';
import {DomSanitizer} from '@angular/platform-browser';
import {WarningComponent} from '../../../../../../shared/components/warning/warning.component';
import {MatDialog} from '@angular/material/dialog';
import {CommonService} from '../../../../../../core/services/common.service';
import {FormControl} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {EnumSignMethod} from "../../../../../../core/constants/contract";
import {DefaultSignImageType, normalizeSignConfigForCompare} from '../default-sign-image-config/default-sign-image-config.component';

@Component({
  selector: 'app-view-digital-certificate',
  templateUrl: './view-digital-certificate.component.html',
  styleUrls: ['./view-digital-certificate.component.scss'],
})
export class ViewDigitalCertificateComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = [
    'stt',
    'userNameManager',
    'action'
  ];
  userName = new FormControl();
  options: string[];
  filteredOptions: Observable<string[]>;


  constructor(
    private digitalCertificateService: DigitalCertificateService,
    public dialogRef: MatDialogRef<ViewDigitalCertificateComponent>,
    private usService: UserService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService,
    public message: Message,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    public commonService: CommonService,
  ) {
    dialogRef.disableClose = true;
    this.id = data.id;
    this.idDetail = data.idDetail;
  }

  id = null;
  idDetail = null;
  certificate = {
    id: null,
    idDetail: null,
    enterpriseId: null,
    enterpriseName: '',
    serialNumber: '',
    taxCode: '',
    activeDate: '',
    expireDate: '',
    isDeleted: false,
    phoneNumber: '',
    typeCertificate: 0,
    typeCertificateInText: '',
    filePath: '',
    issuedTo: '',
    issuedBy: '',
    imagePath: '',
    lstIdNameDTO: [],
    cloudCaUsername: '',
    pin: '',
    isSync: null,
  };

  showPinCode: boolean = false;
  private isDisable: boolean;
  private fileUpload: File;
  private imageUrl: string | ArrayBuffer;
  private stampDivWrapper: HTMLElement;
  private stampSign: HTMLElement;
  private file: File;
  private success: boolean;
  public isFormChanging = false;

  @ViewChildren('focus') focus;
  fileName: any;
  infoMessage: any;
  progress: any;
  isUploading: any;
  public avatarUrl?: string;
  public loading = false;
  previewVisible = false;
  wrongFileFormat = false;
  fileTooLarge = false;
  enumSignMethod = EnumSignMethod;
  expireDate: any;
  isReload: any ;

  // cấu hình ảnh ký mặc định (PYC-84222 task 3)
  defaultSignImageType: DefaultSignImageType = null;
  savedSignConfigJson: string = null;
  savedDrawImageBase64: string = null;
  // loại ảnh đang chọn trên UI + dữ liệu pending từng tab
  pendingDefaultSignImageType: DefaultSignImageType = null;
  pendingSignConfigJson: string = null;
  pendingUploadImageBase64: string = null;
  pendingDrawImageBase64: string = null;
  // ảnh ký nhúng mới trong ảnh hệ thống (raw base64); null = giữ nguyên / tắt tích
  pendingSignatureImageBase64: string = null;
  // user vừa bấm xóa ảnh (tab tải lên) / "Vẽ lại" (tab vẽ) — vô hiệu hóa ảnh cũ đã lưu cho tới khi có ảnh mới
  uploadDeleted = false;
  drawReset = false;
  /**
   * Init component
   */
  ngOnInit() {
    this.getCertificateById(this.id, this.idDetail);
    this.userName.valueChanges.subscribe(value => {
      this.digitalCertificateService.getUserNameAndFullName(value).subscribe((rs: any) => {
        if (rs && Array.isArray(rs)) {
          // @ts-ignore
          this.filteredOptions = rs.map(value1 => value1.name);
        } else if (rs && rs.data && Array.isArray(rs.data)) {
          this.filteredOptions = rs.data.map(value1 => value1.name);
        }
      });
    });
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focus.first.nativeElement.focus(), 500);
  }

  // private _filter(value: string): string[] {
  //   // const filterValue = value.toLowerCase();
  //   // // console.log(this.options.filter(option => option.toLowerCase().includes(filterValue)));
  //   // return this.options ? this.options.filter(option => option.toLowerCase().includes(filterValue)) : null;
  //
  //   if (value) {
  //     this.digitalCertificateService.getUserNameAndFullName(value).subscribe((rs: any) => {
  //       if (rs) {
  //         this.options = rs.map(value1 => value1.name);
  //       }
  //       console.log(this.options.filter(option => option.toLowerCase().includes(value.toLowerCase())));
  //       setTimeout(() => {
  //         return this.options ? this.options.filter(option => option.toLowerCase().includes(value.toLowerCase())) : null;
  //       }, 1500);
  //       // console.log(this.options)
  //       // return this.options.filter(option => option['name'].toLowerCase().includes(value.toLowerCase()))[0];
  //     });
  //   }
  // }

  private getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
  }

  handleChange(info: { file: NzUploadFile }): void {
    this.isFormChanging = true;
    this.wrongFileFormat = false;
    this.fileTooLarge = false;
    switch (info.file.status) {
      case 'uploading':
        this.loading = true;
        break;
      case 'done':
        // Get this url from response in real world.
        this.getBase64(info.file!.originFileObj!, (img: string) => {
          this.loading = false;
          // this.fileUpload = info.file;
          this.avatarUrl = img;
        });
        break;
      case 'error':
        this.toastr.error('Network error');
        this.loading = false;
        break;
    }
  }

  dummyRequest = ({file, onSuccess, onError}) => {
    this.fileUpload = file;
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  }

  beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]) => {
    return new Observable((observer: Observer<boolean>) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.wrongFileFormat = true;
        this.fileTooLarge = false;
        // this.toastr.error(this.message.getMessage('messages.only_accept_png_jpg'));
        observer.complete();
        return;
      }
      const isLt2M = file.size! / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.wrongFileFormat = false;
        this.fileTooLarge = true;
        // this.toastr.error(this.message.getMessage('messages.image_must_than_5m'));
        observer.complete();
        return;
      }
      observer.next(isJpgOrPng && isLt2M);
      observer.complete();
    });
  }

  /**
   * Get certificate by Id certificate
   */
  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  handlePreview = async (file: NzUploadFile) => {
    this.previewVisible = true;
  }

  // lấy ảnh
  getCertificateById(id: string, idDetail: string) {
    this.digitalCertificateService.viewDigitalCertificateDetail(id, idDetail).subscribe(rs => {
      this.certificate = rs.data;
      if(this.certificate.typeCertificate == 10){
        this.certificate.isSync = rs.data.isSync ? this.message.getMessage('button.yes_sign_method_default') : this.message.getMessage('button.no')
      }
      this.getSession();
      const {imagePath} = this.certificate;
      if (imagePath) {
        const imageDataBlob = this.commonService.b64toBlob(imagePath);
        const blobUrl = URL.createObjectURL(imageDataBlob);
        this.avatarUrl = blobUrl;
        // this.previewVisible = true;
      }
      this.loadDefaultSignImageConfig(rs.data);
      // translate type certificate
      switch (this.certificate.typeCertificate) {
        case 0: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_server')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case 1: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_usb')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case 2: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_sim_ca')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case 3: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_otp')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case 4: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_hsm')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case this.enumSignMethod.CLOUD_CA: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_cloud_ca')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case this.enumSignMethod.EASY_CA: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_easy_ca')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
        case this.enumSignMethod.VNEID: {
          this.translate
            .get('digital_certificate_management.cbx_certificate_type.cbx_vneid')
            .subscribe(s => (this.certificate.typeCertificateInText = s));
          break;
        }
      }
    });
  }

  /**
   * Close dialog view certificate
   */
  onClose() {
    this.dialogRef.close(this.isReload);
  }

  onUpdateCertificateImage() {
    const imageChanged = this.pendingDefaultSignImageType !== this.defaultSignImageType
      || this.pendingUploadImageBase64 || this.pendingDrawImageBase64 !== this.savedDrawImageBase64
      || (this.pendingDefaultSignImageType === DefaultSignImageType.SYSTEM
        && (normalizeSignConfigForCompare(this.pendingSignConfigJson) !== normalizeSignConfigForCompare(this.savedSignConfigJson)
          || !!this.pendingSignatureImageBase64));
    // ảnh chỉ được lưu khi block có thay đổi VÀ đang ở trạng thái hợp lệ (có ảnh mới theo tab);
    // chưa hợp lệ (chưa tải lên / chưa Áp dụng / vừa xóa / vừa Vẽ lại) -> bỏ qua ảnh, vẫn lưu phần còn lại
    if (imageChanged && !this.isSignImageInvalid) {
      this.saveDefaultSignImage();
      return;
    }
    let data = {
      ...this.certificate,
      image: this.fileUpload,
      digitalCertificateId: this.certificate.id,
      digitalCertificateDetailId: this.idDetail
    };
    if (this.avatarUrl == '' || this.avatarUrl == null) {
      delete data.image
      delete data.imagePath
    }
    if(this.certificate.typeCertificate == 11){
      this.digitalCertificateService.updatePin({pin: this.certificate.pin, idDetail: this.idDetail, digitalCertificateId: this.id}).subscribe(rs =>{
        this.success = true;
        this.dialogRef.close();
      })
    }

    this.digitalCertificateService.updateImageCertificateBase64(data).then(rs => {
      this.toastr.success(this.message.getMessage('messages.update_success'));
      this.success = true;
      this.dialogRef.close(this.isReload);
    });
  }

  onSelectFile(Event) {
    if (typeof (FileReader) !== 'undefined') {
      let file: File;
      file = Event.target.files[0];
      if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
        if (!this.toastr.findDuplicate(this.message.getMessage('messages.only_accept_pdf'), true, true)) {
          this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
          this.isDisable = true;
        }
      } else {
        if (file.size <= 10485760) {
          this.checkContentTypeThenAddFile(file);
        } else {
          if (!this.toastr.findDuplicate(this.message.getMessage('validation.file'), true, true)) {
            this.toastr.error(this.message.getMessage('validation.file'));
            this.isDisable = true;
          }
        }
      }
    }
  }

  private checkContentTypeThenAddFile(file: File) {
    FileUtils.getContentType(file)
      .then((contentType) => {
        if (ContentType.PNG === contentType || ContentType.BMP === contentType || ContentType.JPEG === contentType) {
          this.fileUpload = file;
          this.imageUrl = URL.createObjectURL(file);
          const reader = new FileReader();
          const image = document.getElementById('#imagePreview');
          if (image) {
            image.setAttribute('src', URL.createObjectURL(file));
          }
          // tslint:disable-next-line:max-line-length
          const imageStamp = `<img src="${URL.createObjectURL(file)}" style="height: ${this.stampDivWrapper.style.height.replace('px', '')}px;"/>`;
          this.stampDivWrapper.innerHTML = imageStamp;
          this.stampSign.setAttribute('src', URL.createObjectURL(file));
        } else {
          this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
          this.isDisable = true;

        }
      }).catch((err) => {
      this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
      this.isDisable = true;

    });
  }

  onChange(file: File) {
    if (file) {
      this.fileName = file.name;
      this.file = file;

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = event => {
        this.imageUrl = reader.result;
      };
    }
  }

  onUpload() {
    this.infoMessage = null;
    this.progress = 0;
    this.isUploading = true;
  }

  /** Nạp cấu hình ảnh ký mặc định đã lưu của chứng thư (PYC-84222 task 3) */
  loadDefaultSignImageConfig(data: any) {
    if (!data) {
      return;
    }
    this.defaultSignImageType = data.defaultSignImageType != null ? data.defaultSignImageType : null;
    this.pendingDefaultSignImageType = this.defaultSignImageType;
    this.savedSignConfigJson = data.defaultSignConfig || null;
    this.pendingSignConfigJson = this.savedSignConfigJson;
    // BE trả base64 trong field drawSignImagePath (trùng tên Entity để ModelMapper map được)
    this.savedDrawImageBase64 = data.drawSignImagePath || null;
    this.pendingDrawImageBase64 = this.savedDrawImageBase64;
    this.pendingUploadImageBase64 = null;
    this.uploadDeleted = false;
    this.drawReset = false;
    this.pendingSignatureImageBase64 = null;
  }

  /** Ảnh upload đã lưu dạng base64 dataURL (lấy từ imagePath BE trả base64) */
  get avatarUrlB64(): string {
    return this.certificate && this.certificate.imagePath ? this.certificate.imagePath : null;
  }

  onDefaultSignImageTypeChange(type: DefaultSignImageType) {
    this.pendingDefaultSignImageType = type;
    this.isFormChanging = true;
  }

  onPendingSignConfigChange(json: string) {
    this.pendingSignConfigJson = json;
    // dialog cấu hình chỉ mở từ tab Ảnh hệ thống: chỉnh config nghĩa là đang chọn loại hệ thống;
    // chứng thư chưa từng cấu hình (type null) phải được nâng lên SYSTEM thì guard lưu mới
    // nhận ra thay đổi và body mới mang defaultSignConfig (PYC-84222)
    if (this.pendingDefaultSignImageType == null) {
      this.pendingDefaultSignImageType = DefaultSignImageType.SYSTEM;
    }
    this.isFormChanging = true;
  }

  onPendingSignatureImageChange(base64: string) {
    this.pendingSignatureImageBase64 = base64;
    // đổi ảnh nhúng cũng là chỉnh config ở tab Ảnh hệ thống
    if (base64 && this.pendingDefaultSignImageType == null) {
      this.pendingDefaultSignImageType = DefaultSignImageType.SYSTEM;
    }
    this.isFormChanging = true;
  }

  onPendingUploadImageChange(base64: string) {
    this.pendingUploadImageBase64 = base64;
    // null = user bấm xóa ảnh trong tab tải lên
    this.uploadDeleted = base64 == null;
    this.isFormChanging = true;
  }

  onPendingDrawImageChange(base64: string) {
    this.pendingDrawImageBase64 = base64;
    // null = user bấm "Vẽ lại" (canvas cleared)
    this.drawReset = base64 == null;
    this.isFormChanging = true;
  }

  /**
   * Luật hợp lệ của tab ảnh (PYC-84222):
   * - Tab trùng loại mặc định đã lưu của cert: chỉ hợp lệ khi có ảnh MỚI (vừa tải lên / vừa Áp dụng) —
   *   tránh lưu lại type + path ảnh cũ không cần thiết.
   * - Tab KHÁC loại mặc định: có ảnh cũ đã lưu là đủ (đổi loại là thay đổi thật, BE dùng lại ảnh cũ),
   *   chưa từng có ảnh cho loại đó thì chưa hợp lệ.
   * - Vừa xóa ảnh (tab tải lên) / "Vẽ lại" (tab vẽ): chưa hợp lệ cho tới khi có ảnh mới.
   * - Tab Ảnh hệ thống: đã là loại mặc định từ trước thì chỉ hợp lệ khi có sửa config (Sửa -> Xong);
   *   chuyển từ loại khác sang thì hợp lệ luôn (đổi loại là thay đổi thật).
   */
  get isSignImageInvalid(): boolean {
    const savedType = this.defaultSignImageType;
    if (this.pendingDefaultSignImageType === DefaultSignImageType.UPLOAD) {
      if (this.pendingUploadImageBase64) {
        return false;
      }
      if (this.uploadDeleted || !this.avatarUrlB64) {
        return true;
      }
      return this.pendingDefaultSignImageType === savedType;
    }
    if (this.pendingDefaultSignImageType === DefaultSignImageType.DRAW) {
      if (this.pendingDrawImageBase64) {
        return false;
      }
      if (this.drawReset || !this.savedDrawImageBase64) {
        return true;
      }
      return this.pendingDefaultSignImageType === savedType;
    }
    if (this.pendingDefaultSignImageType === DefaultSignImageType.SYSTEM) {
      // SYSTEM đã là loại mặc định từ trước: chỉ hợp lệ khi có sửa config (Sửa -> Xong với thay đổi)
      // hoặc có ảnh ký nhúng mới (JSON không chứa base64 nên config giống hệt vẫn là thay đổi thật);
      // chuyển từ loại khác sang SYSTEM là thay đổi thật -> hợp lệ luôn
      if (savedType === DefaultSignImageType.SYSTEM) {
        // so sánh bản đã chuẩn hoá: JSON saved từ BE có signatureImageBase64/signatureImagePath
        // gắn thêm — không normalize thì config không đổi vẫn bị coi là khác
        return normalizeSignConfigForCompare(this.pendingSignConfigJson) === normalizeSignConfigForCompare(this.savedSignConfigJson)
          && !this.pendingSignatureImageBase64;
      }
      return false;
    }
    return false;
  }

  /**
   * Body gửi API cập nhật ảnh ký mặc định: chỉ gửi đúng loại đang chọn.
   * - 0 hệ thống: gửi JSON config
   * - 1 upload: gửi ảnh mới nếu có thay đổi, không gửi nếu giữ nguyên
   * - 2 vẽ: gửi ảnh vẽ mới
   */
  buildDefaultSignImageBody() {
    const body: any = {
      digitalCertificateId: this.certificate.id,
      idDetail: this.idDetail,
      defaultSignImageType: this.pendingDefaultSignImageType
    };
    if (this.pendingDefaultSignImageType === DefaultSignImageType.SYSTEM) {
      body.defaultSignConfig = this.pendingSignConfigJson;
      if (this.pendingSignatureImageBase64) {
        body.signatureImageBase64 = this.pendingSignatureImageBase64;
      }
    }
    if (this.pendingDefaultSignImageType === DefaultSignImageType.UPLOAD) {
      if (this.pendingUploadImageBase64) {
        const base64 = this.pendingUploadImageBase64.split(',')[1];
        body.base64Image = base64;
        body.imageName = 'sign-image-' + Date.now() + '.png';
      }
    }
    if (this.pendingDefaultSignImageType === DefaultSignImageType.DRAW && this.pendingDrawImageBase64) {
      const base64 = this.pendingDrawImageBase64.split(',')[1];
      // tái sử dụng API cũ: ảnh vẽ gửi qua base64Image, BE phân biệt bằng defaultSignImageType = 2
      body.base64Image = base64;
      body.imageName = 'draw-sign-' + Date.now() + '.png';
    }
    return body;
  }

  /** Lưu riêng cấu hình ảnh ký mặc định qua API 3.3.5 */
  saveDefaultSignImage() {
    const body = this.buildDefaultSignImageBody();
    this.digitalCertificateService.updateDefaultSignImage(body).subscribe(rs => {
      if (rs && rs.success) {
        this.toastr.success(this.message.getMessage('messages.update_success'));
        this.defaultSignImageType = this.pendingDefaultSignImageType;
        this.savedSignConfigJson = this.pendingDefaultSignImageType === DefaultSignImageType.SYSTEM
          ? this.pendingSignConfigJson : this.savedSignConfigJson;
        if (this.pendingDefaultSignImageType === DefaultSignImageType.DRAW && this.pendingDrawImageBase64) {
          this.savedDrawImageBase64 = this.pendingDrawImageBase64;
        }
        if (this.pendingDefaultSignImageType === DefaultSignImageType.UPLOAD) {
          // tải lại chi tiết để lấy ảnh mới nhất
          this.getCertificateById(this.id, this.idDetail);
        }
        this.pendingUploadImageBase64 = null;
        this.pendingSignatureImageBase64 = null;
        this.isFormChanging = false;
        this.isReload = {isReload: true};
      } else {
        this.toastr.error(rs && rs.message ? rs.message : this.message.getMessage('messages.error_proccessing'));
      }
    }, err => {
      this.toastr.error(this.message.getMessage('messages.error_proccessing'));
    });
  }

  onCancel() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close(this.isReload);
        } else {
          dialogRe.close();
        }
      });
    } else {
      this.dialogRef.close(this.isReload);
    }
  }

  confirmDelete() {
        this.avatarUrl = '';
        this.fileUpload = null;
        this.certificate.imagePath = '';
        this.isFormChanging = true;
  }
  getSession(){
    if(this.certificate.typeCertificate !== 10){
      return
    }
    this.digitalCertificateService.endSessionCloudCa({
      digitalCertificateId: this.certificate.id,
      digitalCertificateDetailId: this.idDetail
    }).subscribe(res => {
      console.log(res);
      if(res.success){
        this.expireDate = res.data ? res.data.expireDate.replace(/-/g, '/') : null;
      }else {
        this.toastr.error(res.message)
      }
      
    })
  }

  deleteSession(){
    const dialogRe = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.message.getMessage('digital_certificate_management.title_confirm_delete_session') + this.certificate.issuedTo
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (rs) {
        this.digitalCertificateService.deleteSessionCloudCa({
          digitalCertificateId: this.certificate.id,
          digitalCertificateDetailId: this.idDetail
        }).subscribe(res =>{
          if(res.success){
            this.isReload = {isReload: true}
            this.toastr.success(this.message.getMessage('digital_certificate_management.delete_session_success'))
            this.getSession()
          } else {
            this.toastr.error(res.message)
          }
        })
      } else {
        dialogRe.close();
      }
    });
  }
}
